import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ReducerState } from '@/services/common/lib/reducerState';
import { twMerge } from 'tailwind-merge';
import { setToggleBBDisplay } from '../../../../services/table/tableActions';
import PotAmount from '@/components/PotAmount';
import { COLORS } from '@/constants/COLORS';

interface TotalPotProps {
  tableId: string;
}

const TotalPot: FC<TotalPotProps> = ({ tableId }) => {
  const user = useSelector((state: ReducerState) => state.auth);
  const dispatch = useDispatch();
  const table = useSelector((state: ReducerState) => state.tables[tableId]);

  const handleBBDisplay = (setting: boolean) => {
    dispatch(setToggleBBDisplay(tableId, setting));
  };

  const bigBlind = table?.bigBlind;
  const totalPot = table?.handState?.state?.totalPot || 0;
  const displayInBBEnabled = !!(table?.bigBlind && table?.displayInBBEnabled);

  if (totalPot <= 0) {
    return null;
  }

  const onClickHandler = () => {
    handleBBDisplay(!displayInBBEnabled);
  };

  return (
    <div
      onClick={onClickHandler}
      className={twMerge(
        'flex items-center justify-center rounded-md bg-ph-purple px-2.5 py-0.5 text-base font-bold text-white',
        user.settings?.stackInBigBlindsEnabled && bigBlind && 'cursor-pointer',
      )}
    >
      Total pot:{' '}
      {
        <PotAmount
          amount={totalPot}
          bigBlind={bigBlind}
          shouldDisplayInBB={displayInBBEnabled ?? user.settings?.stackInBigBlindsEnabled}
          fill={COLORS.white}
        />
      }
    </div>
  );
};

export default TotalPot;
